import axios from 'axios';

export interface LLMModelPricing {
  id: string;
  version: string;
  inputCostPerMillion: number;
  outputCostPerMillion: number;
  inputTokensPerUniversal: number;
  outputTokensPerUniversal: number;
  status: string;
  source: string;
  createdAt: string | null;
}

export interface LLMModel {
  id: string;
  provider: string;
  providerDisplayName: string;
  modelId: string;
  displayName: string;
  isActive: boolean;
  upstreamStatus: string | null;
  contextLimit: number | null;
  outputLimit: number | null;
  releaseDate: string | null;
  lastUpdated: string | null;
  activePricing: LLMModelPricing | null;
  pendingPricings: LLMModelPricing[];
}

export interface LLMModelsAdminResponse {
  models: LLMModel[];
  lastSyncedAt: string | null;
  suggestedModel: string | null;
  universalToken: {
    pricePerUniversalToken: number;
    providerCostShare: number;
  };
}

export interface ModelsDevSyncSummary {
  syncedAt: string;
  providersProcessed: number;
  modelsConsidered: number;
  newModels: string[];
  updatedModels: number;
  pendingPricingChanges: number;
  skipped: boolean;
}

const API_BASE_URL = '/api/admin/llm-models';

export const llmModelService = {
  async getAdminStatus(): Promise<{ isAdmin: boolean }> {
    const response = await axios.get<{ isAdmin: boolean }>('/api/admin/me');
    return response.data;
  },

  async getAllModels(): Promise<LLMModelsAdminResponse> {
    const response = await axios.get<LLMModelsAdminResponse>(API_BASE_URL);
    return response.data;
  },

  async setModelActive(modelId: string, isActive: boolean): Promise<LLMModel> {
    const response = await axios.patch<LLMModel>(`${API_BASE_URL}/${modelId}`, { isActive });
    return response.data;
  },

  async activatePricing(modelId: string, pricingId: string): Promise<LLMModelPricing> {
    const response = await axios.post<LLMModelPricing>(
      `${API_BASE_URL}/${modelId}/pricing/${pricingId}/activate`
    );
    return response.data;
  },

  async triggerSync(): Promise<ModelsDevSyncSummary> {
    const response = await axios.post<ModelsDevSyncSummary>(`${API_BASE_URL}/sync`);
    return response.data;
  },
};
